<template>
	<div class="content_box">
		<div class="title">
			<span class="left_shu"></span>
			历史任务
		</div>
		<div class="table_box">
			<el-table :data="tableData" style="width: 100%;">
				<el-table-column prop="carNo" label="车辆编号" align='center'>
				</el-table-column>
				<el-table-column prop="carName" label="车辆名称" align='center'>
				</el-table-column>
				<el-table-column prop="routeName" label="路线名称" align='center'>
				</el-table-column>
				<el-table-column prop="description" label="描述" align='center'>
				</el-table-column>
				<el-table-column prop="state" label="状态" align='center'>
					<template slot-scope="scope">
						{{scope.row.state==0?'已创建':scope.row.state==1?'执行中':scope.row.state==2?'已暂停':scope.row.state==3?'已取消':'已完成'}}
					</template>
				</el-table-column>
				<el-table-column prop="createTime" label="创建时间" align='center'>
				</el-table-column>
			</el-table>
			<div class="table_paging">
				<el-pagination @current-change="handleCurrentChange" :current-page="currentPage" :page-size="pageSize"
					:total="currentTotal" background layout="prev, pager, next">
				</el-pagination>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				tableData: [], //数据
				currentPage: 1, //页数
				pageSize: 10, //每页数量
				currentTotal: 0, //总数
			}
		},
		mounted() {
			this.getData()
		},
		methods: {
			async getData() {
				let result = await this.request.post("/v1.0/drivingMission/getPageData", {
					pageNum: this.currentPage,
					pageSize: this.pageSize,
					type: 2,
				});
				this.tableData = result.data.dataList
				this.currentTotal = result.data.totalCount - 0
			},
			handleCurrentChange(val) {
				console.log(val)
				this.currentPage = val
				//点击下一页的时候 重新调用接口从后端取分页数据;{ current: this.currentPage } 为传给后端的字段
				this.getData()
			},
		}
	}
</script>

<style>
</style>
